import { Label } from '@/common/ui/label'
import { Info } from 'lucide-react'

export const LINESettingsForm = () => {
	return (
		<div className="space-y-4 rounded-lg border p-4">
			<div>
				<Label className="text-base">ตั้งค่า LINE</Label>
				<p className="text-sm text-muted-foreground">
					การตั้งค่า LINE Messaging API
				</p>
			</div>

			<div className="flex items-start gap-3 rounded-lg bg-muted p-4">
				<Info className="h-5 w-5 text-muted-foreground" />
				<div className="space-y-1">
					<p className="text-sm font-medium">
						LINE Messaging ถูกตั้งค่าที่ Backend แล้ว
					</p>
					<p className="text-sm text-muted-foreground">
						ระบบจะส่งข้อความผ่าน LINE Official Account ที่ตั้งค่าไว้โดยอัตโนมัติ
					</p>
				</div>
			</div>
		</div>
	)
}
